import { oldBaseApi } from "../../api";
import { User } from "../types";

export type CurrentUser = Pick<
  User,
  "firstName" | "middleName" | "lastName" | "employment" | "userId"
>;

export const currentUser = (): Promise<CurrentUser> => {
  return oldBaseApi.get<CurrentUser>("api/users/current").then((r) => r.data);
};
